var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"play"),React.createElement("path",{"d":"M42.2,33L25.7,42.5a1,1,0,0,1-1.7-1V22.5a1,1,0,0,1,1.7-1L42.2,31A1.1,1.1,0,0,1,42.2,33ZM58,32A26,26,0,1,1,32,6,26,26,0,0,1,58,32Zm-4,0A22,22,0,1,0,32,54,22,22,0,0,0,54,32Z","transform":"translate(-6 -6)","key":1})]);
}

PlayInline.defaultProps = {"fill":"currentColor","data-name":"Play button","viewBox":"0 0 52 52","x":"0px","y":"0px"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
